@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

@animationAllEasingFor300ms: all 300ms ease;

.dropdown-container {
  position: relative;
  margin-top: 3px;
}

.dropdown {
  position: absolute;
  left: -115px;
  width: auto;
  max-height: 50vh;
  overflow-y: scroll;
  border: 1px solid @filter-dropdown-menu--border-color;
  border-radius: 4px;
}

.filterform {
  position: absolute;
  opacity: 0;
  left: 100px;
}

.nested-dropdown-content {
  max-height: 325px;
  overflow: auto;
}

.dropdown-push-left {
  left: -115px;
  opacity: 0;
}

.dropdown-animate-left {
  left: -250px;
  opacity: 0;
  transition: @animationAllEasingFor300ms;
}

.dropdown-animate-right {
  left: -115px;
  opacity: 1;
  transition: @animationAllEasingFor300ms;
}

.form-push-left {
  left: -170px;
  opacity: 1;
}

.form-animate-left {
  left: -170px;
  opacity: 1;
  transition: @animationAllEasingFor300ms;
}

.form-animate-right {
  left: 0;
  opacity: 0;
  transition: @animationAllEasingFor300ms;
}
